import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-date-table',
  templateUrl: './date-table.component.html',
  styleUrls: ['./date-table.component.scss']
})
export class DateTableComponent implements OnInit {

  public isLoad : boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
